export const CONFIGURATION_KEY = "configuration";
export const FIRMWARE_KEY = "firmware";
export const USER_MANAGEMENT_KEY = "userManagement";
export const FEATURE_KEY_KEY = "featureKey";
export const LICENSE_KEY = "license";
export const VOUCHER_KEY = "voucher";
export const VOUCHER_OVERVIEW_KEY = "voucherOverview";
export const VOUCHER_SEARCH_KEY = "voucherSearch";

type RoleName = {
  [key: string]: {
    id: string;
    name: string;
    oldName: string;
  };
};

export const ROLENAMES: RoleName = {
  [CONFIGURATION_KEY]: {
    id: "970497b4-aa4f-4c84-adda-08da7070c15f",
    name: "Configuration",
    oldName: "Configuration",
  },
  [FIRMWARE_KEY]: {
    id: "f4f5ba64-a105-4ad0-addb-08da7070c15f",
    name: "Firmware",
    oldName: "Firmwares",
  },
  [USER_MANAGEMENT_KEY]: {
    id: "d04cbcdc-6e25-462a-addc-08da7070c15f",
    name: "User Management",
    oldName: "Users",
  },
  [FEATURE_KEY_KEY]: {
    id: "fc232803-2e51-4348-addd-08da7070c15f",
    name: "Feature Key",
    oldName: "FeatureKeys",
  },
  [LICENSE_KEY]: {
    id: "da3ef691-dacb-4c78-adde-08da7070c15f",
    name: "License",
    oldName: "Licenses",
  },
  [VOUCHER_KEY]: {
    id: "e7de5183-bf66-455e-addf-08da7070c15f",
    name: "Voucher",
    oldName: "Vouchers",
  },
  [VOUCHER_OVERVIEW_KEY]: {
    id: "c505ecd7-f5bc-4472-ade0-08da7070c15f",
    name: "Voucher Overview",
    oldName: "Entitlements",
  },
  [VOUCHER_SEARCH_KEY]: {
    id: "7f3227dc-69e6-4cef-ade1-08da7070c15f",
    name: "Voucher Search",
    oldName: "VoucherSearch",
  },
};

export const DEFINE_LICENSE_KEY = "defineLicense";
export const DEFINE_VOUCHER_KEY = "defineVoucher";
export const EXPORT_VOUCHER_KEY = "exportVoucher";
export const OVERRIDE_VOUCHER_KEY = "overrideVoucher";
export const FULL_ACCESS_KEY = "fullAccess";
export const READ_ACCESS_KEY = "readAccess";

type AccessName = {
  [key: string]: {
    id: string;
    name: string;
  };
};

export const ACCESSNAMES: AccessName = {
  [DEFINE_LICENSE_KEY]: {
    id: "b81d0823-8763-4075-7d4c-08da707ee351",
    name: "Define License",
  },
  [DEFINE_VOUCHER_KEY]: {
    id: "425df8bc-d1b4-4cac-7d4d-08da707ee351",
    name: "Define Voucher",
  },
  [EXPORT_VOUCHER_KEY]: {
    id: "1dbbfd62-2bf8-4113-7d4e-08da707ee351",
    name: "Export Voucher",
  },
  [OVERRIDE_VOUCHER_KEY]: {
    id: "497bc169-1bea-40e5-c528-08de01ba0de9",
    name: "Override Voucher Settings",
  },
  [FULL_ACCESS_KEY]: {
    id: "2414ec72-eddf-4723-7d4b-08da707ee351",
    name: "Full Access",
  },
  [READ_ACCESS_KEY]: {
    id: "8ca987ca-d74b-45bd-7d4a-08da707ee351",
    name: "Read Access",
  },
};
